import { render, staticRenderFns } from "./sinistre.vue?vue&type=template&id=1a69bea2&scoped=true"
import script from "./sinistre.vue?vue&type=script&lang=js"
export * from "./sinistre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69bea2",
  null
  
)

export default component.exports